import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';
import DossierApp from './DossierApp';
import PitchApp from './PitchApp';
import { subscribe } from './lib/viewBridge';
import './mode-selector.css';

const STORAGE_KEY = 'lio-active-view';
const HINT_KEY = 'lio-dossier-hint';

export default function App() {
  const [view, setView] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dossier' || stored === 'pitch') return stored;
    } catch { /* storage disabled */ }
    // Default: pitch (apresentação comercial) — o dossier é secundário.
    return 'pitch';
  });
  const [dossierHint, setDossierHint] = useState(() => {
    try {
      const raw = sessionStorage.getItem(HINT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, view); } catch { /* ignore */ }
    document.title = view === 'dossier'
      ? 'Liofilândia · Planeamento executivo'
      : 'Liofilândia — O futuro conserva-se hoje.';
  }, [view]);

  useEffect(() => {
    return subscribe((request) => {
      if (request.view === 'dossier' || request.view === 'pitch') {
        setView(request.view);
      }
      if (request.hint) {
        setDossierHint(request.hint);
        try { sessionStorage.setItem(HINT_KEY, JSON.stringify(request.hint)); } catch { /* ignore */ }
      }
    });
  }, []);

  const consumeHint = () => {
    setDossierHint(null);
    try { sessionStorage.removeItem(HINT_KEY); } catch { /* ignore */ }
  };

  return (
    <>
      <div className="mode-selector-bar">
        <div className="mode-selector" role="group" aria-label="Modo de visualização" data-testid="mode-selector">
          <button
            type="button"
            aria-pressed={view === 'pitch'}
            onClick={() => setView('pitch')}
            data-testid="mode-pitch"
          >
            Apresentação
          </button>
          <button
            type="button"
            aria-pressed={view === 'dossier'}
            onClick={() => setView('dossier')}
            data-testid="mode-dossier"
          >
            Planeamento
          </button>
        </div>
      </div>
      {view === 'dossier' ? (
        <DossierApp preselectHint={dossierHint} onHintConsumed={consumeHint} />
      ) : (
        <PitchApp />
      )}
      <Toaster position="bottom-center" richColors closeButton />
    </>
  );
}
